/* eslint-disable func-names */
import Swiper from 'swiper/js/swiper';
import 'swiper/css/swiper.min.css';

// eslint-disable-next-line no-unused-vars
const howToSwiper = new Swiper('.howto-swiper', {
  pagination: {
    el: '.howto-swiper-pagination'
  },
  breakpoints: {
    800: {
      slidesPerView: 3
    }
  }
});

let opportunitiesSwiper;

const tabs = ['Налоговый календарь', 'Калькулятор налогов', 'Управление доходом', 'Декларация по итогам года'];

function handleBreakpointChange(query) {
  if (query.matches) {
    if (opportunitiesSwiper !== undefined) {
      opportunitiesSwiper.destroy(true, true);
    }

    opportunitiesSwiper = new Swiper('.opportunities-swiper', {
      pagination: {
        el: '.opportunities-swiper-pagination'
      }
    });
  } else {
    if (opportunitiesSwiper !== undefined) {
      opportunitiesSwiper.destroy(true, true);
    }

    opportunitiesSwiper = new Swiper('.opportunities-swiper', {
      effect: 'fade',
      pagination: {
        el: '.opportunities-swiper-pagination',
        clickable: true,
        // eslint-disable-next-line object-shorthand
        renderBullet: function(index, className) {
          return `<div class="${className}">${tabs[index]}</div>`;
        }
      }
    });
  }
}

const breakpoint = window.matchMedia('(max-width: 1100px)');
handleBreakpointChange(breakpoint);
breakpoint.addListener(handleBreakpointChange);
